import React from "react"
import { NavLink } from "react-router-dom"
import { Grid, Icon, Card } from "semantic-ui-react"
import { getAge } from "uikit"
const toTitleCase = text =>
  text.length > 1
    ? text.charAt(0).toUpperCase() + text.substr(1).toLowerCase()
    : ""

const getDescription = (
  gender,
  health_status,
  is_tobacco_user,
  credit_rating
) => {
  let description = []
  gender && description.push(toTitleCase(gender))
  health_status && description.push(`${toTitleCase(health_status)} Health`)
  if (is_tobacco_user !== null) {
    description.push(is_tobacco_user ? "Tobacco User" : "Non-Tobacco User")
  }
  credit_rating && description.push(`${toTitleCase(credit_rating)} Credit`)
  return description.join(", ")
}

export const Client = ({
  id,
  first_name,
  birth_date,
  gender,
  health_status,
  is_tobacco_user,
  credit_rating,
  baseUrl
}) => (
  <Card>
    <Card.Content>
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column textAlign="left">
            <NavLink
              to={`${baseUrl}/person/${id}`}
              className="navlink"
              data-testid="clientProfile"
            >
              <span className="GenericCard__LinkTitle">
                {first_name}
                <Icon name="chevron right" size="small" />
              </span>
            </NavLink>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="GenericCard__Balance">{getAge(birth_date)}</p>
            <p className="greyed-text">age</p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="left">
            <p className="greyed-text">
              {getDescription(
                gender,
                health_status,
                is_tobacco_user,
                credit_rating
              )}
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
)
